import './app_modern_icons.less';

import 'zoomforth_iconfonts/zf-app-modern.font.js';

// If you need an icon which is in fontawesome you can get its SVG from
// https://github.com/encharm/Font-Awesome-SVG-PNG/tree/master/white/svg
// (Put the .svg in the `zoomforth_iconfonts/zf-app-modern-files` folder.)

import classNames from 'classnames';
import React from 'react'; 

export const Icon = ({ ident, className, name, spin, variant, ...props }) =>
  <i 
    className={classNames(
      'zf-app-modern-icon',
      `zfam-name-${name ? name : ident}`,
      `zfam-${ident}`,
      {
        'zfam-spin':spin,
        'zfam-dot-circle-o-dark': variant === 'dark'
      },
      className
    )} 
    {...props} 
  />;


//
// ATTENTION: DO NOT USE THESE IN THE PAGE VIEWER! (Use `external_modern_icons.jsx`)
//

// Keep these alphabatized please!

export const AccordionIcon = props =>
  <Icon name="accordion" {...props} />;

export const AccountIcon = props =>
  <Icon name="account" ident="user" {...props} />;

export const AlertIcon = props =>
  <Icon name="alert" ident="exclamation-circle" {...props} />;

export const AlignCenterIcon = props =>
  <Icon ident="align-center" {...props} />;
  
export const AlignJustifyIcon = props =>
  <Icon ident="align-justify" {...props} />;

export const AlignLeftIcon = props =>
  <Icon ident="align-left" {...props} />;
  
export const AlignRightIcon = props =>
  <Icon ident="align-right" {...props} />;

export const AnalyticsIcon = props =>
  <Icon ident="analytics" {...props} />;

export const AnchorIcon = props =>
  <Icon ident="anchor" {...props} />;

export const ArchiveIcon = props =>
  <Icon ident="archive" {...props} />;

export const ArrowCircleDownIcon = props =>
  <Icon ident="arrow-circle-down" {...props} />;

export const ArrowCircleLeftIcon = props =>
  <Icon ident="arrow-circle-left" {...props} />;

export const ArrowCircleRightIcon = props =>
  <Icon ident="arrow-circle-right" {...props} />;

export const ArrowCircleUpIcon = props =>
  <Icon ident="arrow-circle-up" {...props} />;

export const ArrowLeftIcon = props =>
  <Icon ident="arrow-left" {...props} />;

export const ArrowRightIcon = props =>
  <Icon ident="arrow-right" {...props} />;

export const AsteriskIcon = props =>
  <Icon ident="asterisk" {...props} />;

export const BanIcon = props =>
  <Icon ident="ban" {...props} />;

export const CalendarIcon = props =>
  <Icon ident="calendar" {...props} />;

export const CaretDownIcon = props =>
  <Icon ident="caret-down" {...props} />;

export const CaretLeftIcon = props =>
  <Icon ident="caret-left" {...props} />;

export const CaretRightIcon = props =>
  <Icon ident="caret-right" {...props} />;

export const CaretUpIcon = props =>
  <Icon ident="caret-up" {...props} />;

export const ChangeSectionIcon = props =>
  <Icon ident="change-section" {...props} />;

export const CheckCircleIcon = props =>
  <Icon ident="check-circle" {...props} />;

export const CheckCircleOpenIcon = props =>
  <Icon ident="check-circle-o" {...props} />;

export const CheckSquareIcon = props =>
  <Icon ident="check-square" {...props} />;

export const CheckSquarePartialIcon = props =>
  <Icon ident="check-square-partial" {...props} />;

export const ChevronCircleDownIcon = props =>
  <Icon ident="chevron-circle-down" {...props} />;

export const ChevronCircleLeftIcon = props =>
  <Icon ident="chevron-circle-left" {...props} />;

export const ChevronCircleRightIcon = props =>
  <Icon ident="chevron-circle-right" {...props} />;

export const ChevronCircleUpIcon = props =>
  <Icon ident="chevron-circle-up" {...props} />;

export const ChevronDownIcon = props =>
  <Icon ident="chevron-down" {...props} />;

export const ChevronLeftIcon = props =>
  <Icon ident="chevron-left" {...props} /> ;

export const ChevronRightIcon = props =>
  <Icon ident="chevron-right" {...props} /> ;

export const ChevronModifiedRightIcon = props =>
  <Icon ident="modified-chevron-right" {...props} /> ;

export const ChevronUpIcon = props =>
  <Icon ident="chevron-up" {...props} /> ;

export const CircleIcon = props =>
  <Icon ident="circle" {...props} />;

export const CircleOpenIcon = props =>
  <Icon ident="circle-o" {...props} />;

export const CircleOpenDottedIcon = props =>
  <Icon ident="dot-circle-o" {...props} />;

export const ClipboardIcon = props =>
  <Icon ident="clipboard" {...props} />;

export const ClipboardIconRegular = props =>
  <Icon
    ident="clipboard-regular"
    { ...props }
  />;

export const CloudUploadIcon = props =>
  <Icon ident="cloud-upload" {...props} />;

export const ClockIcon = props =>
  <Icon ident="clock-o" {...props} />;

export const CloseIcon = props =>
  <Icon ident="close" {...props} />;

export const CodeIcon = props =>
  <Icon ident="code" {...props} />;

export const CompassSlashIcon = props =>
  <Icon ident="compass-slash" {...props} />;

export const CollaborationIcon = props =>
  <Icon ident="collaboration" {...props} />;

export const CopyIcon = props =>
  <Icon ident="copy" {...props} />;

export const CropIcon = props =>
  <Icon ident="crop" {...props} />;

export const DesktopIcon = props =>
  <Icon ident="desktop" {...props} />;

export const DownloadIcon = props =>
  <Icon ident="download" {...props} />;

export const DragArrowsIcon = props =>
  <Icon ident="arrows-v" {...props} />;

export const DragIcon = props =>
  <Icon ident="bars" {...props} />;

export const EditIcon = props =>
  <Icon name="edit" ident="pencil" {...props} />;

export const EmailIcon = props =>
  <Icon ident="envelope-o" {...props} />;

export const EmailClosedIcon = props =>
  <Icon ident="envelope" {...props} />;

export const ErrorIcon = props =>
  <Icon name="error" ident="exclamation-triangle" {...props} /> ;

export const ExpandIcon = (props) =>
  <Icon ident="expand" {...props} />;

export const ExternalLinkIcon = props =>
  <Icon ident="external-link" {...props} />;

export const FacebookIcon = (props) =>
  <Icon ident="facebook-square" {...props} />;

export const FileIcon = props =>
  <Icon ident="file-o" {...props} />;

export const FilterIcon = props =>
  <Icon ident="filter" {...props} />;

export const FileImageIcon = props =>
  <Icon ident="file-image-o" {...props} />;

export const FileVideoIcon = props =>
  <Icon ident="file-video-o" {...props} />;

export const FileZipIcon = props =>
  <Icon ident="file-zip-o" {...props} />;

export const FolderIcon = props =>
  <Icon name="label" ident="folder" {...props} />;

export const FormIcon = props =>
  <Icon ident="form" {...props} />;

export const FullscreenIcon = props =>
  <Icon ident="arrows-alt" {...props} />;

export const GlobeIcon = props =>
  <Icon ident="globe" {...props} />;

export const GridIcon = props =>
  <Icon ident="grid" {...props} />;

export const HandRightIcon = props =>
  <Icon ident="hand-or-right" {...props} />;

export const HeartbeatIcon = props =>
  <Icon ident="heartbeat" {...props} />;

export const HiddenIcon = props => // from fa eye-slash
  <Icon ident="hidden" {...props} />;

export const HomeIcon = props =>
  <Icon ident="home" {...props} />;

export const ImageIcon = props =>
  <Icon ident="image" {...props} />;

export const InfoCircleIcon = props =>
  <Icon ident="info-circle" {...props} />;

export const KeyIcon = props =>
  <Icon ident="key" {...props} />;

export const LayerIcon = props =>
  <Icon ident="layer" {...props} />;

export const LeaveThisContextIcon = props =>
  <Icon ident="arrow-circle-right" {...props} />;

export const LightbulbIcon = props =>
  <Icon ident="lightbulb-o" {...props} />;

export const LinkIcon = props =>
  <Icon ident="link" {...props} />;

export const LinkedInIcon = (props) =>
  <Icon ident="linkedin-square" {...props} />;

export const LoadingIcon = props =>
  <Icon name="loading" ident="circle-o-notch" spin {...props} />;

export const LoadingNoSpinIcon = props =>
  <Icon name="loading" ident="circle-o-notch" {...props} />;

export const LockIcon = props =>
  <Icon ident="lock" {...props} />;

export const ObjectLockIcon = props =>
  <Icon ident="object-lock" {...props} />;

export const ObjectInheritedLockIcon = props =>
  <Icon ident="object-inherited-lock" {...props} />;

export const MagicIcon = props =>
  <Icon ident="magic" {...props} />;

export const MfaIcon = props =>
  <Icon ident="mfa" {...props} />;

export const MenuIcon = props =>
  <Icon ident="menu" {...props} />;

export const MineIcon = props =>
  <Icon ident="my-page" {...props} />;

export const MobileIcon = props =>
  <Icon ident="mobile" {...props} />;

export const NewTabIcon = props =>
  <Icon name="new-tab" ident="preview" {...props} />;

export const PageIcon = props =>
  <Icon ident="page" {...props} />;

export const PageOpenIcon = props =>
  <Icon ident="page-open" {...props} />;

export const PasteIcon = props =>
  <Icon ident="paste" {...props} />;

export const PdfIcon = props =>
  <Icon name="pdf" ident="file-pdf-o" {...props} />;

export const PdfWideIcon = props =>
  <Icon ident="pdf-wide" {...props} />;

export const PermissionMissingIcon = props =>
  <Icon name="permission-missing" ident="ban" {...props} />;

export const PlusIcon = props =>
  <Icon ident="plus" {...props} />;

export const PowerPointIcon = props =>
  <Icon ident="file-powerpoint-o" {...props} />;

export const PresentationIcon = props =>
  <Icon ident="presentation" {...props} /> ;

export const PreviewIcon = props =>
  <Icon ident="preview" {...props} /> ;

export const PromptsIcon = props =>
  <Icon name="prompts" ident="prompts" {...props} />;

export const QuickCustomizationIcon = props =>
  <Icon name="quick-customization" ident="bolt" {...props} />;

export const RedirectIcon = props =>
  <Icon name="redirect" ident="external-link-square" {...props} />;

export const RefreshIcon = props =>
  <Icon ident="refresh" {...props} /> ;

export const SearchIcon = props =>
  <Icon ident="search" {...props} />;

export const SettingsIcon = props =>
  <Icon ident="settings" {...props} /> ;

export const ShareIcon = props =>
  <Icon name="share" ident="share-alt" {...props} />;

export const SitemapIcon = props =>
  <Icon ident="sitemap" {...props} />;

export const SlideNavArrowIcon = (props) => 
  <Icon ident='slide-nav-arrow' {...props} />;
export const SlideNavChevronIcon = (props) => 
  <Icon ident='slide-nav-chevron' {...props} />;
export const SlideNavCircularIcon = (props) => 
  <Icon ident='slide-nav-circular' {...props} />;
export const SlideNavHideIcon = (props) => 
  <Icon ident='slide-nav-hide' {...props} />;

export const SlideshowIcon = props =>
  <Icon ident="slideshow" {...props} />;


export const SquareIcon = props =>
  <Icon ident="square" {...props} />;

export const StarIcon = props =>
  <Icon ident="star" {...props} />;

export const StarOpenIcon = props =>
  <Icon ident="star-o" {...props} />;

export const SubpageIcon = props =>
  <Icon ident="subpage" {...props} />;

export const SuccessIcon = props =>
  <Icon ident="success" {...props} />;

export const SupportIcon = props =>
  <Icon name="support" ident="question-circle" {...props} />;

export const TabletIcon = props =>
  <Icon ident="tablet" {...props} />;

export const TeamIcon = props =>
  <Icon ident="team-page" {...props} />;

export const TemplateIcon = props =>
  <Icon ident="template" {...props} />;

export const ThemesIcon = props =>
  <Icon name="themes" ident="themes" {...props} />;

export const TextIcon = props =>
  <Icon ident="text" {...props} />;

export const TextSectionIcon = props =>
  <Icon ident="text-section" {...props} />;

export const TileIcon = props =>
  <Icon ident="tile" {...props} />;

export const XCircle = props =>
  <Icon ident="times-circle" {...props} />;

export const TooltipIcon = props =>
  <Icon name="tooltip" ident="question-circle" {...props} />;

export const TrashIcon = (props)=>
  <Icon ident="trash" {...props} />;

export const TwitterIcon = (props) =>
  <Icon ident="twitter-square" {...props} />;

export const UnarchiveIcon = (props) =>
  <Icon ident="unarchive" {...props} />;

export const UndoIcon = (props)=>
  <Icon ident="undo" {...props} />;

export const UnlinkIcon = props =>
  <Icon ident="unlink" {...props} />;

export const UnlockIcon = props =>
  <Icon ident="unlock-alt" {...props} />;
  
export const VerticalAlignBottomIcon = props =>
  <Icon ident="vertical-align-bottom" {...props} />;

export const VerticalAlignMiddleIcon = props =>
  <Icon ident="vertical-align-middle" {...props} />;

export const VerticalAlignTopIcon = props =>
  <Icon ident="vertical-align-top" {...props} />;

export const VideoIcon = props =>
  <Icon name="video" ident="video-camera" {...props} />;

export const VideoPlayIcon = props =>
  <Icon ident="video-play" {...props} />;

export const VideoPlaylistIcon = props =>
  <Icon ident="video-playlist" {...props} />;

export const VisibleIcon = props =>
  <i className="fa fa-eye" {...props} />;

export const WarningIcon = props =>
  <Icon name="warning" ident="exclamation-circle" {...props} />;

export const WebPreviewIcon = props =>
  <Icon ident="web-preview" {...props} />;

export const ZoomforthLogoIcon = props => 
  <Icon name="zoomforth-logo" ident="zf-logo" {...props} />;
